import React from 'react';
import qaStyles from './qa.module.sass';

export default props => {

  const { qa } = props

  return (
    <li className={qaStyles.li}>
      <h3 className={qaStyles.question}>{qa.question}</h3>
      <p className={qaStyles.answer}>{qa.answer}</p>
    </li>
  )

};